const STORAGE_KEY = 'cod:lastOrder';

function b64urlDecode(value) {
  let s = value.replace(/-/g, '+').replace(/_/g, '/');
  while (s.length % 4) s += '=';
  const binary = atob(s);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

function summaryFromHash() {
  const raw = window.__codMerciHash || location.hash;
  if (!raw || !raw.startsWith('#o=')) return null;
  try {
    return JSON.parse(b64urlDecode(raw.slice(3)));
  } catch {
    return null;
  }
}

function isSummary(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return false;
  if (typeof data.orderName === 'string' && data.orderName) return true;
  if (typeof data.eventId === 'string' && data.eventId) return true;
  return Number.isFinite(Number(data.total));
}

function clearHash() {
  try {
    history.replaceState(history.state, '', location.pathname + location.search);
  } catch {
    /* the hash is cosmetic */
  }
  window.__codMerciHash = null;
}

function consumeSummary() {
  let data = null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    if (raw) data = JSON.parse(raw);
  } catch {
    data = null;
  }
  if (!isSummary(data)) data = summaryFromHash();
  if (isSummary(data)) {
    clearHash();
    return data;
  }
  if (window.__codMerciHash || location.hash.startsWith('#o=')) clearHash();
  return null;
}

function formatMoney(value, currency, locale) {
  const amount = Number(value) || 0;
  try {
    return new Intl.NumberFormat(locale === 'fr' ? 'fr-MA' : 'ar-MA', {
      style: 'currency',
      currency: currency || 'MAD',
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency || 'MAD'}`;
  }
}

function pushEvent(name, params) {
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
  } catch {
    /* tracking never blocks the page */
  }
}

function trackPurchase(data) {
  if (!data || data.duplicate) return;
  const px = data.pixels || {};
  const value = Number(data.total) || 0;
  const currency = data.currency || 'MAD';
  const transactionId = data.orderName || data.eventId || '';
  const items = (Array.isArray(data.items) ? data.items : []).map((item) => ({
    item_id: String(item.id || item.t || ''),
    item_name: String(item.t || ''),
    price: Number(item.up ?? item.p) || 0,
    quantity: Number(item.q) || 1,
  }));
  const purchaseParams = { transaction_id: transactionId, value, currency, items };

  if (px.ga4) pushEvent(px.leadInsteadOfPurchase ? 'generate_lead' : 'purchase', purchaseParams);
  if (px.ads && px.adsLabel) {
    pushEvent('conversion', {
      send_to: `${px.ads}/${px.adsLabel}`,
      transaction_id: transactionId,
      value,
      currency,
    });
  }

  try {
    if (px.fb && typeof window.fbq === 'function') {
      window.fbq(
        'track',
        px.leadInsteadOfPurchase ? 'Lead' : 'Purchase',
        {
          value,
          currency,
          content_type: 'product',
          content_ids: items.map((item) => item.item_id),
          contents: items.map((item) => ({
            id: item.item_id,
            quantity: item.quantity,
            item_price: item.price,
          })),
          num_items: items.reduce((sum, item) => sum + item.quantity, 0),
        },
        { eventID: data.eventId || transactionId },
      );
    }
    if (px.tiktok && window.ttq && typeof window.ttq.track === 'function') {
      window.ttq.track(
        px.leadInsteadOfPurchase ? 'SubmitForm' : 'CompletePayment',
        {
          value,
          currency,
          content_type: 'product',
          content_id: items[0]?.item_id || '',
          quantity: items.reduce((sum, item) => sum + item.quantity, 0),
        },
        { event_id: data.eventId || transactionId },
      );
    }
  } catch {
    /* tracking never blocks the page */
  }
}

function renderSummary(root, data) {
  const isDuplicate = Boolean(data.duplicate);
  const hello = root.querySelector('[data-cod-merci-hello]');
  const nameEl = root.querySelector('[data-cod-merci-name]');
  if (hello && nameEl && data.firstName) {
    nameEl.textContent = data.firstName;
    hello.hidden = false;
  }

  const orderEl = root.querySelector('[data-cod-merci-order]');
  if (orderEl) {
    if (data.orderName) orderEl.textContent = data.orderName;
    const orderRow = orderEl.closest('.merci__row');
    if (orderRow && (!data.orderName || isDuplicate)) orderRow.hidden = true;
  }

  const cityRow = root.querySelector('[data-cod-merci-city-row]');
  const cityEl = root.querySelector('[data-cod-merci-city]');
  if (cityRow && cityEl && data.city) {
    cityEl.textContent = data.city;
    cityRow.hidden = false;
  }

  const itemsEl = root.querySelector('[data-cod-merci-items]');
  if (itemsEl && !isDuplicate && Array.isArray(data.items) && data.items.length) {
    for (const item of data.items) {
      const li = document.createElement('li');
      li.className = 'merci__item';
      const title = document.createElement('span');
      title.className = 'merci__item-title';
      title.textContent = item.t || '';
      const qty = document.createElement('span');
      qty.className = 'merci__item-qty';
      qty.textContent = `x${Number(item.q) || 1}`;
      const price = document.createElement('span');
      price.className = 'merci__item-price';
      price.textContent = formatMoney(item.p, data.currency, data.locale);
      li.append(title, qty, price);
      itemsEl.appendChild(li);
    }
  }
  if (isDuplicate) {
    const itemsLabel = root.querySelector('.merci__items-label');
    if (itemsLabel) itemsLabel.hidden = true;
    if (itemsEl) itemsEl.hidden = true;
  }

  const totalEl = root.querySelector('[data-cod-merci-total]');
  if (totalEl) {
    totalEl.textContent = formatMoney(data.total, data.currency, data.locale);
    const totalRow = totalEl.closest('.merci__row');
    if (totalRow && isDuplicate) totalRow.hidden = true;
  }

  const duplicate = root.querySelector('[data-cod-merci-duplicate]');
  if (duplicate && isDuplicate) duplicate.hidden = false;

  const wa = root.querySelector('[data-cod-merci-whatsapp]');
  if (wa) {
    const text = wa.dataset.codMerciWhatsappText || '';
    const message = [text, data.orderName || ''].filter(Boolean).join(' ');
    wa.href = `${wa.href.split('?')[0]}?text=${encodeURIComponent(message)}`;
  }

  const summary = root.querySelector('[data-cod-merci-summary]');
  if (summary) summary.hidden = false;
}

const root = document.querySelector('[data-cod-merci]');
const designMode = Boolean(root?.hasAttribute('data-cod-merci-design-mode'));

if (root) {
  root.dataset.codMerciReady = 'true';
  if (designMode) {
    const summary = root.querySelector('[data-cod-merci-summary]');
    if (summary) summary.hidden = false;
    const orderEl = root.querySelector('[data-cod-merci-order]');
    if (orderEl) orderEl.textContent = '#12345';
    const totalEl = root.querySelector('[data-cod-merci-total]');
    if (totalEl) {
      totalEl.textContent = formatMoney(379, 'MAD', document.documentElement.lang || 'ar');
    }
  } else {
    const data = consumeSummary();
    if (data) {
      renderSummary(root, data);
      trackPurchase(data);
    }
  }
}
